import { clsx } from 'clsx';
import {
  streamDescription,
  subscriptionInfo,
} from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner.css.ts';

const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

const pluralize = (count: number, unit: string) =>
  `${count} ${unit}${count === 1 ? '' : 's'}`;

const formatTimeLeft = (cancelAt: string) => {
  const leftMs = new Date(cancelAt).getTime() - Date.now();
  if (leftMs >= DAY_MS) return pluralize(Math.floor(leftMs / DAY_MS), 'day');
  if (leftMs >= HOUR_MS) return pluralize(Math.floor(leftMs / HOUR_MS), 'hour');
  return 'less than an hour';
};

export const SubscriptionExpiryNotice = ({
  cancelAt,
}: {
  cancelAt: string;
}) => {
  return (
    <div className={clsx(streamDescription, subscriptionInfo)}>
      Subscription expires in {formatTimeLeft(cancelAt)}
      <br />
      You can resubscribe after expiration date
    </div>
  );
};
